"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _connectToSF = require("../../store/connectToSF/connectToSF.selectors");

var _SettingsItem = _interopRequireDefault(require("../../../Settings/components/SettingsItem/SettingsItem"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    button: {
      color: palette.link.main,
      border: "1px solid ".concat(palette.divider),
      backgroundColor: palette.common.white,
      boxShadow: 'none',
      width: 100
    },
    docsLink: {
      display: 'inline-block'
    }
  };
});

var SfConnectionSettings = function SfConnectionSettings(_ref2) {
  var _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title,
      description = _ref2.description,
      onChange = _ref2.onChange,
      _ref2$overrideStyles = _ref2.overrideStyles,
      overrideStyles = _ref2$overrideStyles === void 0 ? {} : _ref2$overrideStyles;
  var classes = useStyles();
  var isConnected = (0, _reactRedux.useSelector)(_connectToSF.getIsCampaignConnected);
  var isSFConnectionLoading = (0, _reactRedux.useSelector)(_connectToSF.getCampaignConnectionIsLoading);
  var connectionValue = (0, _reactRedux.useSelector)(_connectToSF.getConnectionValue);
  var sfCampaignLink = (0, _reactRedux.useSelector)(_connectToSF.getSfCampaignLink);
  var onSfCampaignLinkClick = (0, _react.useCallback)(function () {
    return window.open(sfCampaignLink || '', '_blank');
  }, [sfCampaignLink]);
  var connectionStateValue = (0, _react.useMemo)(function () {
    if (!sfCampaignLink) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, connectionValue);
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, connectionValue, ";", ' ', /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
      onClick: onSfCampaignLinkClick,
      className: classes.docsLink
    }, "Click here to view the connected campaign in Salesforce"));
  }, [sfCampaignLink, connectionValue, classes.docsLink, onSfCampaignLinkClick]);
  return /*#__PURE__*/_react.default.createElement(_SettingsItem.default, {
    title: title,
    description: description,
    isLoading: isSFConnectionLoading,
    valueNode: connectionStateValue,
    collapsible: false,
    overrideClasses: overrideStyles,
    controls: /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      container: true,
      direction: "row",
      justifyContent: "flex-end",
      xs: 3
    }, !isConnected && /*#__PURE__*/_react.default.createElement(_material.Button, {
      "data-testid": "Connect_to_Salesforce_SFConnectionSettings.Change.Button",
      variant: "contained",
      onClick: onChange,
      className: classes.button,
      disabled: isSFConnectionLoading
    }, isSFConnectionLoading ? /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      spin: true,
      color: "inherit",
      icon: "spinner"
    }) : 'Connect'))
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(SfConnectionSettings);

exports.default = _default;